import { render } from "./etBreadcrumb.vue?vue&type=template&id=6245c402"
import script from "./etBreadcrumb.vue?vue&type=script&lang=js"
export * from "./etBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__